<template>
  <div
    class="side-menu-item"
    @click="$emit('click');"
  >
    <router-link
      :to="route"
      class="item-link"
    >
      <li
        :class="[`item-${name}`, {'item--selected': selectedNav === name}]"
        class="menu-item is-flex"
      >
        <div>
          <i
            :class="[`icon-${icon}`]"
            class="menu-item-icon has-margin-horizontal-2"
          />
        </div>
        <div class="menu-item-label">
          <span class="is-size-8"> {{ label }} </span>
        </div>
      </li>
    </router-link>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useRootStore } from '@/stores/root';


export default {
  name: 'SideMenuItem',
  props: {
    routeName: { type: String, default: '' },
    routeParams: { type: Object, default: () => {} },
    name: { type: String, required: true },
    label: { type: String, required: true },
    icon: { type: String, default: 'none' },
  },
  emits: ['click'],
  computed: {
    // Vuex mapGetters(['selectedNav']) → Pinia rootStore.
    ...mapState(useRootStore, ['selectedNav']),
    route() {
      return { name: this.routeName, params: { ...this.routeParams } };
    },
  },
};
</script>

<style lang="scss">

.side-menu-item{

  .item-link{
    color: $blue-big-stone;
    &:hover{
      color: $blue-big-stone;
    }
  }

  .menu-item {
    color: $white;
    align-items: center;
    border-left: 3px solid transparent;
    height: 38px;
     @include mobile {
      height: 44px;
    }

    // &:hover {
    //   background-color: $black-mirage;
    //   border-left: 3px solid $blue-ribbon;
    //   .menu-item-icon {
    //     color: $white;
    //   }
    // }
  }
  .menu-item:hover,
  .menu-item.item--selected {
    width: 90%;
    color: $white;
    background-color: #fc3f5b;
    border-radius: 0px 2rem 2rem 0px;
    border-left: 3px solid transparent;
    .menu-item-icon {
      font-size: 20px;
      color: $white;
    }
  }

  .menu-item .menu-item-icon {
    color: $grey-storm;
    // @include icon-shape(38px, 14px, 10px, 0px);
    // @include desktop {
    //   @include icon-shape(25px, 10px, 7px, 0px);
    // }
    @include mobile {
      font-size: 18px;
    }
    @include icon-shape(25px, 14px, 7px, 0px);
  }

  // .item-dashboard .menu-item-icon{
  //   color: $blue-robins-egg;
  //   background-color: $cyan-light;
  // }
  // .item-customers .menu-item-icon{
  //   color: $grenadier;
  //   background-color: $brown-blanched-almond;
  // }
  // .item-products .menu-item-icon{
  //   color: $green-malachite;
  //   background-color: $green-scandal;
  // }
  // .item-commissions .menu-item-icon{
  //   color: $brown;
  //   background-color: $tuft-bush;
  // }
  // .item-revenue .menu-item-icon{
  //   color: $blue-havelock;
  //   background-color: $lavender;
  // }
  // .item-statistics .menu-item-icon{
  //   color: $fuchsia;
  //   background-color: $lavander-blush;
  // }
  // .item-tools .menu-item-icon{
  //   color: $blue-steel;
  //   background-color: $white-catskill;
  // }
  // .item-logout .menu-item-icon{
  //   color: $yellow;
  //   background-color: $yellow-lemon-chiffon;
  // }

  // .menu-item-icon {
  //   color: $white;
  //   background-color: $grey;
  // }

  .icon-none:before {
    content: "?";
    font-size: 20px;
    margin-bottom: 6px;
  }

}

</style>
